import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { routes } from "../constants/Routes";
import drawing from "../img/drawingStartPage.png";
import "./StartPage.css";

export default function StartPage() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-column m-4 container">
      <div className="title-start flex"> DEAD EQUITY REDUCER 9000</div>
      <div className="flex flex-row">
        <div className="left-column flex flex-column">
          <div className="sub-title-start"> Co-founder alignment</div>
          <div className="paragraph-start">
            This tool is designed to facilitate the co-founder alignment
            conversation and tackles one of the most fundamental issues in early
            stage companies: “dead equity”. After completing the tool, the
            founders will be provided with a co-founder alignment report.
          </div>
          <div className="paragraph-start">
            We highly recommend you to watch the video below before diving into
            the tool.
          </div>
          <iframe
            className="mt-8"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/gGd5LSEiIPE"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
        <div className="right-column flex flex-column">
          <img src={drawing} className="start-image" />
          <div
            className="button ml-auto flex items-center"
            onClick={() => navigate(routes.main)}
          >
            <div className="mr-2">Start Reducing</div>
            <FiArrowRight />
          </div>
        </div>
      </div>
    </div>
  );
}
